export async function callOCCProfileAPI(
  inProgress,
  prod_loc_occ,
  occ_profile,
  schema_name
) {
  var jsonData = "";
  if (inProgress) {
    jsonData = {
      vipsOrder: "Inprogress",
      vipsSchemaName: schema_name,
      vipsPL: prod_loc_occ,
    };
  }
  const data = {
    x_pendingExternalorder: inProgress ? JSON.stringify(jsonData) : jsonData,
  };
  const requestOptions = {
    method: "PUT",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  await fetch(
    process.env.REACT_APP_UPDATE_OCC_PROFILE_API_URL + "/" + occ_profile,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {})
    .catch((err) => {});
}
